import html2pdf from 'html2pdf.js';
import { jsPDF } from 'jspdf';
import { FACILITY_IDS } from './facilities';
import { getActivePrintFacilityId } from './printServer';

/** Strawberry Patch Zebras dither gray JPEG edges. 87 Central DYMOs stay on the existing PDF path. */
export function isZebraStickerPrinter() {
  return getActivePrintFacilityId() === FACILITY_IDS.STRAWBERRY_PATCH;
}

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

/** Snap antialiased grays to pure black or white so a 1-bit Zebra does not dither them. */
function thresholdCanvas(canvas, cutoff = 188) {
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  if (!ctx) return;
  const image = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const pixels = image.data;
  for (let i = 0; i < pixels.length; i += 4) {
    const luminance = pixels[i] * 0.2126 + pixels[i + 1] * 0.7152 + pixels[i + 2] * 0.0722;
    const value = luminance < cutoff ? 0 : 255;
    pixels[i] = value;
    pixels[i + 1] = value;
    pixels[i + 2] = value;
    pixels[i + 3] = 255;
  }
  ctx.putImageData(image, 0, 0);
}

/**
 * @param {HTMLElement} element
 * @param {object} opt html2pdf options. Central uses these unchanged.
 * @param {{ zebra?: boolean }} [options]
 */
export async function stickerElementToBase64(element, opt, { zebra = false } = {}) {
  if (!zebra) {
    const pdfBlob = await html2pdf().set(opt).from(element).output('blob');
    return blobToBase64(pdfBlob);
  }

  const zebraOpt = {
    ...opt,
    image: { type: 'png', quality: 1 },
    html2canvas: {
      ...opt.html2canvas,
      scale: 6,
      logging: false,
    },
  };

  const canvas = await html2pdf().set(zebraOpt).from(element).toCanvas().get('canvas');
  thresholdCanvas(canvas);

  const [widthIn, heightIn] = opt.jsPDF.format;
  const pdf = new jsPDF({
    unit: 'in',
    format: [widthIn, heightIn],
    orientation: 'portrait',
    compress: true,
  });
  pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, widthIn, heightIn);
  return blobToBase64(pdf.output('blob'));
}
